.root {
  @keyframes spin {
    0% {
      transform: rotateZ(0deg);
    }

    100% {
      transform: rotateZ(360deg);
    }
  }

  g {
    transform-origin: 50% 50%;
    animation: spin 0.7s infinite steps(8);
  }
}
